import icon20 from "../assets/icons/icon20.svg";
import icon21 from "../assets/icons/icon21.svg";
import icon22 from "../assets/icons/icon22.svg";
import icon6 from "../assets/icons/icon6.svg";

export const resultData = {
  about_company_page: [
    {
      number: "85%",
      desc: "Рекомендуют нас своим знакомым и коллегам"
    },
    {
      number: "9/10",
      desc: "Находят работу во время сопровождения"
    },
    {
      number: "4+",
      desc: "Года на рынке"
    },
    {
      number: "2000+",
      desc: "Клиентов разных стран и индустрий"
    },
  ],
  career_consult_page: [
    {
      number: "800+",
      desc: "Проведенных карьерных консультаций"
    },
    {
      number: "10/10",
      desc: "Метрика удовлетворенности консультацией"
    },
    {
      number: "x2",
      desc: "Средний рост зарплаты наших клиентов"
    },
    {
      number: "20",
      desc: "Cтран, где мы закрываем карьерные запросы"
    },
    {
      number: "4+",
      desc: "Года работы компании Прохорова Консалт"
    },
  ],
  cv_ready_page: [
    {
      number: "700+",
      desc: "Клиентов, которым мы помогли создать резюме"
    },
    {
      number: "10/10",
      desc: "Метрика удовлетворенности консультацией"
    },
    {
      number: "x2",
      desc: "Средний рост зарплаты наших клиентов"
    },
    {
      number: "20",
      desc: "Cтран, где мы закрываем карьерные запросы"
    },
    {
      number: "4+",
      desc: "Года работы компании Прохорова Консалт"
    },
  ],
  search_support_page: [
    {
      number: "200+",
      desc: "Клиентов, которые купили сопровождение"
    },
    {
      number: "1",
      desc: "Месяц – это среднее время поиска работы в сопровождении"
    },
    {
      number: "80%",
      desc: "Клиентов, приходят по сарафанному радио"
    },
    {
      number: "20",
      desc: "Cтран, где мы закрываем карьерные запросы"
    },
    {
      number: "4+",
      desc: "Года работы компании Прохорова Консалт"
    },
  ],
  probation_support_page: [
    {
      number: "1000+",
      desc: "Клиентов, которым мы помогли решить карьерные задачи"
    },
    {
      number: "50+",
      desc: "Успешно-пройденных испытательных сроков с нашей командой"
    },
    {
      number: "x2",
      desc: "Средний рост зарплаты наших клиентов"
    },
    {
      number: "20",
      desc: "Cтран, где мы закрываем карьерные запросы"
    },
    {
      number: "4+",
      desc: "Года работы компании Прохорова Консалт"
    },
  ],
  vacancies_page: [
    {
      number: "200+",
      desc: "Клиентов, которые купили сопровождение"
    },
    {
      number: "2",
      desc: "Месяца – это среднее время поиска работы в сопровождении"
    },
    {
      number: "80%",
      desc: "Клиентов, приходят по сарафанному радио"
    },
    {
      number: "20",
      desc: "Cтран, где мы закрываем карьерные запросы"
    },
    {
      number: "4+",
      desc: "Года работы компании Прохорова Консалт"
    },
  ],
  talkitout_page: [
    {
      number: "500+",
      desc: "Часов коучинговой практики"
    },
    {
      number: "50+",
      desc: "Клиентов, достигших результатов"
    },
    {
      number: "x2",
      desc: "Рост к профессиональной уверенности"
    },
    {
      number: "60%",
      desc: "Cредний показатель снижения тревожности"
    },
    {
      number: "4",
      desc: "Cессии и выгорание начнет отступать"
    },
  ],
  it_hiring_page: [
    {
      number: "100+",
      desc: "Закрытых вакансий"
    },
    {
      number: "10 стран",
      desc: "Где мы имеем опыт подбора специалистов"
    },
    {
      number: "4+",
      desc: "Года работы компании Прохорова Консалт"
    },
  ],
  it_training_page: [
    {
      number: "60+",
      desc: "Студентов"
    },
    {
      number: "3",
      desc: "Недели, среднее время поиска работы наших студентов"
    },
    {
      number: "x3",
      desc: "Средний рост зарплаты наших студентов за год"
    },
    {
      number: "10",
      desc: "Стран, где живут наши студенты"
    },
    {
      number: "4+",
      desc: "Года мы обучаем профессиям ИТ подбора"
    },
  ],
  linkedin_boost_page: [
    {
      icon: icon20,
      desc: "x2 к просмотрам профиля за первый месяц",
    },
    {
      icon: icon21,
      desc: "Входящие запросы от рекрутеров и нанимающих менеджеров",
    },
    {
      icon: icon6,
      desc: "Международные контакты и предложения",
    },
    {
      icon: icon22,
      desc: "Упакованный профиль с четким позиционированием",
    },
  ]
}
